import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { DTPInfoGraph } from './DTPInfoGraph'
import {
  TermsAndConditions,
  AdditionalParagraphProps,
} from '@components/TermsAndConditions/TermsAndConditions'

const AdditionalParagraph: React.FC<AdditionalParagraphProps> = ({ trans }) => (
  <>
    <div className="generic__micropayment-info-content">{trans?.content}</div>

    <div className="generic__micropayment-info-graph">
      <DTPInfoGraph />
    </div>

    <div className="generic__micropayment-info-content">{trans?.openBanking}</div>
  </>
)

export const TermsAndConditionsDTPInfoPage = observer(() => {
  const store = useContext(StoreContext)
  const { DTPInfoPage: trans } = store.TranslationsState.translations

  return (
    <TermsAndConditions
      showHeader={true}
      header={trans.header}
      showTitle={false}
      showRequired={false}
      buttonText={trans.proceed}
      AdditionalParagraph={AdditionalParagraph}
      additionalParagraphProps={{ trans: trans }}
    />
  )
})
